import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { GetFaqsResponse } from '../models/faq.models';

export interface IFaqService {
  getFaqs(packageId: string): Promise<GetFaqsResponse>;
}

@Injectable({ providedIn: 'root' })
export class FaqService implements IFaqService {
  private readonly http = inject(HttpClient);

  getFaqs(signingId: string): Promise<GetFaqsResponse> {
    return firstValueFrom(this.http.get<GetFaqsResponse>(`/api/v1/faqs/${signingId}`));
  }
}

